import { z } from 'zod';

export const sessionUserSchema = z.object({
  id: z.string(),
  isGuest: z.boolean(),
  username: z.string().nullable(),
  role: z.enum(['user', 'admin']),
});
export type SessionUser = z.infer<typeof sessionUserSchema>;

export const meResponseSchema = z.object({ user: sessionUserSchema.nullable() });
export type MeResponse = z.infer<typeof meResponseSchema>;

export const errorBodySchema = z.object({
  error: z.object({ code: z.string(), message: z.string(), details: z.unknown().optional() }),
});
export type ErrorBody = z.infer<typeof errorBodySchema>;
